import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

/**
 * Client-side redirect handler.
 * Checks the current path against the cms_redirects table.
 * On Hostinger, these should be handled via .htaccess for true 301s.
 * This is a fallback for the SPA.
 */
const RedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkRedirect = async () => {
      const path = location.pathname;

      const { data } = await supabase
        .from("cms_redirects" as any)
        .select("new_url, redirect_type")
        .eq("old_url", path)
        .eq("is_active", true)
        .maybeSingle();

      if (data && (data as any).new_url !== path) {
        // Increment hit count (fire and forget)
        supabase
          .from("cms_redirects" as any)
          .update({ hit_count: 0, last_hit_at: new Date().toISOString() } as any)
          .eq("old_url", path)
          .then(() => {});

        navigate((data as any).new_url, { replace: true });
      }
    };

    checkRedirect();
  }, [location.pathname, navigate]);

  return null;
};

export default RedirectHandler;
